import {useMemo} from 'react';
import {useField, useFormState} from 'react-final-form';
import {useIntl} from 'react-intl';

import {validateDate} from 'coreUtils/dates';

import messages from '../messages';

export const useBirthdayValidator = (name: string) => {
	const intl = useIntl();

	const {submitErrors, submitFailed} = useFormState();

	const {
		meta: dayMeta,
		input: {value: dayValue},
	} = useField(`${name}.day`);
	const {
		meta: monthMeta,
		input: {value: monthValue},
	} = useField(`${name}.month`);
	const {
		meta: yearMeta,
		input: {value: yearValue},
	} = useField(`${name}.year`);

	const isTouched = useMemo(
		() => dayMeta.touched && monthMeta.touched && yearMeta.touched,
		[dayMeta, monthMeta, yearMeta],
	);

	const dateValue = useMemo(
		() => ({
			day: Number(dayValue),
			month: Number(monthValue),
			year: Number(yearValue),
		}),
		[dayValue, monthValue, yearValue],
	);

	const hasBirthdayError = useMemo(() => {
		const isEmpty = !dateValue.day && !dateValue.month && !dateValue.year;

		if (isEmpty || validateDate(dateValue) && !submitFailed ) {
			return false;
		}

		if (isTouched && !validateDate(dateValue) && !submitFailed) {
			return intl.formatMessage(messages.invalid);
		}

		if (submitErrors?.[name]) {
			return submitErrors[name];
		}

		return false;
	}, [submitErrors, isTouched, dateValue]);

	return {hasBirthdayError};
};
